import React, { Component, useState, useEffect } from "react";
import { SimpleApp } from "components/app";
import Paginate from "components/paginate";
import { DatePicker, Search } from "components/common";

const getCustomClass = () => {
    switch (hp.store.numberOfColumnToShow) {
        case 1:
            return "col-sm-12";
        case 2:
            return "col-sm-12 col-md-6";
        case 3:
            return "col-sm-12 col-md-6 col-lg-4";
        case 6:
            return "col-sm-12 col-md-6 col-lg-2";
        case 12:
            return "col-sm-12 col-md-6 col-lg-2";
        default:
            return "col-sm-12 col-md-6 col-lg-3";
    }
};

const CourseCard = ({ action }) => {
    let badges = [];
    if (action.badge) {
        badges.push(<div className={`badge-stats ${action.badge_color}`}>{action.badge}</div>);
    }

    if (action.available || action.available === 0) {
        badges.push(
            action.available <= 0 ? (
                <div className="badge-stats red">{__("sites_soldout")}</div>
            ) : (
                <div className="badge-stats green">
                    {__(action.available == 1 ? "sites_subscription_avaliable" : "sites_subscriptions_avaliable", {
                        available: action.available,
                    })}
                </div>
            )
        );
    }

    return (
        <div className={`card-wrapper ${hp.store.course_card_image_top ? 'course_card_image_top' : '' }`} onClick={(e) => e.currentTarget.classList.toggle("flipped")}>
            <div className="card-flip">
                {/* Frente do card */}
                <div className="card-front">
                    <div className="badge-wrapper">{badges}</div>

                    <div className="card-wrapper__image">
                        <img src={action.image} alt={action.name} />
                        <div className="card-wrapper__overlay"></div>
                    </div>
                    <div className="card-wrapper__info">
                        <p className="subtitle">{action.coursetype_description}</p>
                        <p className="subtitle-date">{action.start}</p>
                        <h3 className="title">{action.name}</h3>
                    </div>
                </div>

                {/* Verso do card */}
                <div className="card-back">
                    <div className="card-back__content">
                        <div className="card-back__content-body">
                            {action.start && action.pub_date == 1 && (
                                <p className="description">
                                    <i className="ri-calendar-line"></i>
                                    <strong>Início:</strong> {action.start}
                                </p>
                            )}
                            {action.end && action.pub_date == 1  && (
                                <p className="description">
                                    <i className="ri-calendar-line"></i>
                                    <strong>Fim:</strong> {action.end}
                                </p>
                            )}
                            {action.location && (
                                <p className="description">
                                    <i className="ri-map-pin-line"></i>
                                    <strong>Local:</strong> {action.location}
                                </p>
                            )}
                            {action.courseaction_ref && (
                                <p className="description">
                                    <i className="ri-barcode-line"></i>
                                    <strong>Ref.:</strong> {action.courseaction_ref}
                                </p>
                            )}
                            {action.duration_effect && (
                                <p className="description">
                                    <i className="ri-time-line"></i>
                                    <strong>Duração:</strong> {action.duration_effect}
                                </p>
                            )}
                            {action.coursetype_description && (
                                <p className="description">
                                    <i className="ri-chat-quote-line"></i>
                                    <strong>Tipo:</strong> {action.coursetype_description}
                                </p>
                            )}
                            {action.area && (
                                <p className="description">
                                    <i className="ri-map-2-line"></i>
                                    <strong>Área:</strong> {action.area}
                                </p>
                            )}

                            {action.trainers && (
                                <p className="description">
                                    <i className="ri-map-2-line"></i>
                                    <strong>Formador(es):</strong> {action.trainers}
                                </p>
                            )}
                           
                        </div>

                        <div className="card-back__content-footer text-center">
                            <a href={action.link} className="hs-main-btn">
                                Saber mais
                            </a>
                            {hp.store.can_show_social_buttons && (
                                <div className="course-social-media">
                                    <a aria-label={action.name} target="_blank" href={action.facebook}>
                                        <em className="fa fa-facebook-f"></em>
                                    </a>

                                    <a aria-label={action.name} target="_blank" href={action.linkedin}>
                                        <em className="fa fa-linkedin"></em>
                                    </a>

                                    <a aria-label={action.name} target="_blank" href={action.email}>
                                        <em className="fa fa-envelope"></em>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SearchContainer = ({ searchParams, selectedFilters, onSearch, active }) => {
    const [formValues, setFormValues] = useState(selectedFilters);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        handleFilterValues(value, name);
    };

    const handleDatePicker = (value, field) => {
        handleFilterValues(value, field);
    };

    const handleSearch = (value) => {
        handleFilterValues(value, "keywords");
    };

    const handleFilterValues = (value, field) => {
        const updatedFormValues = { ...formValues, [field]: value };
        setFormValues(updatedFormValues);
        onSearch(updatedFormValues);
    };

    return (
        <div className={(active ? "active " : "") + "filter-container"}>
            <div className="container">
                <div className="row justify-content-center">
                    <div id="form_filter" className="col col-md-10">
                        <div className="form-row row text-left">
                            <div className="form-group col-md-6">
                                <Search name="keywords" className="input-sm search" doSearch={handleSearch} />
                            </div>
                            <div className="form-group col-md-3">
                                <DatePicker
                                    model={selectedFilters}
                                    name="evt_start"
                                    onChange={(value) => handleDatePicker(value, "evt_start")}
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <DatePicker
                                    model={selectedFilters}
                                    name="evt_end"
                                    onChange={(value) => handleDatePicker(value, "evt_end")}
                                />
                            </div>
                        </div>

                        <div className="form-row row text-left">
                            <div className="form-group col-md-3">
                                <select
                                    className={(!formValues.area_code ? "default" : "") + " form-control"}
                                    name="area_code"
                                    id="area_code"
                                    value={formValues.area_code || ""}
                                    onChange={handleInputChange}
                                >
                                    <option value="">{__("attrs_area")}</option>
                                    {Object.entries(searchParams.carea).map(([key, value]) => (
                                        <option key={key} value={key}>
                                            {value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group col-md-3">
                                <select
                                    className={(!formValues.course_type ? "default" : "") + " form-control"}
                                    name="course_type"
                                    id="course_type"
                                    value={formValues.course_type || ""}
                                    onChange={handleInputChange}
                                >
                                    <option value="">{__("attrs_type")}</option>
                                    {Object.entries(searchParams.ctype).map(([key, value]) => (
                                        <option key={key} value={key}>
                                            {value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group col-md-3">
                                <select
                                    className={(!formValues.local_code ? "default" : "") + " form-control"}
                                    name="local_code"
                                    id="local_code"
                                    value={formValues.local_code || ""}
                                    onChange={handleInputChange}
                                >
                                    <option value="">{__("attrs_local")}</option>
                                    {Object.entries(searchParams.location).map(([key, value]) => (
                                        <option key={key} value={key}>
                                            {value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

class CourseListManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            actions: {
                data: null,
                meta: {},
            },
            searchParams: {
                carea: null,
                ctype: null,
                location: null,
            },
            selectedFilters: {},
            currentPage: 1,
            isFilterVisible: false,
        };
    }

    componentDidMount() {
        this.loadData(1, true);
    }

    loadData(page = false, initialOnly = false) {
        const { selectedFilters } = this.state;
        const currentPage = page || this.state.currentPage;

        http.get("/homes/index.json", { page: currentPage, ...selectedFilters }, (response, success) => {
            if (success && response.actions) {
                if (initialOnly) {
                    const searchParams = {
                        carea: response.carea,
                        ctype: response.ctype,
                        location: response.location,
                    };
                    this.setState({ searchParams });
                }

                this.setState({ actions: response.actions, currentPage: page });
            } else {
                this.setState({ actions: [] });
            }
        });
    }

    handleSearch = (selectedFilters) => {
        this.setState({ selectedFilters }, () => {
            this.loadData();
        });
    };

    toggleFilters = () => {
        this.setState({ isFilterVisible: !this.state.isFilterVisible, selectedFilters: {} }, (e) => {
            if (!this.state.isFilterVisible) {
                this.loadData();
            }
        });
    };

    render() {
        const { actions, searchParams, selectedFilters, isFilterVisible } = this.state;
        if (actions.data === null) {
            return <div className="courses-loading">A carregar cursos...</div>;
        }

        const customClass = getCustomClass();

        return (
            <SimpleApp>
                <div id="all-courses">
                    <div className={(!isFilterVisible ? "default " : "") + "toolbar"}>
                        <div className="toolbar__left">
                            <h3 className="main-title">{__("sites_course_catalog")}</h3>
                        </div>
                        <div className="toolbar__right">
                            <button onClick={this.toggleFilters}>
                                {isFilterVisible ? (
                                    <>
                                       {__("sites_clear_filters")} <i className="ri-close-line ms-2"></i>
                                    </>
                                ) : (
                                    <>
                                        {__("sites_find_course")} <i className="ri-search-line ms-2"></i>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                    <SearchContainer
                        active={isFilterVisible}
                        searchParams={searchParams}
                        selectedFilters={selectedFilters}
                        onSearch={this.handleSearch}
                    />
                    <div className="container-fluid max-width-80">
                        <div className="row">
                            <Paginate
                                items={actions.data}
                                itemCount={actions.meta.item_count}
                                itemsPerPage={actions.meta.item_per_page}
                                forcePage={this.state.currentPage - 1}
                                previousLabel={<i className="ri-arrow-left-s-line"></i>}
                                nextLabel={<i className="ri-arrow-right-s-line"></i>}
                                classNameEl={`col-12 ${customClass}`}
                                paginationContainer={(content) => <>{content}</>}
                                onPageChange={page => this.loadData(page.selected + 1)}
                                renderItem={(item, i) => <CourseCard key={i} action={item} />}
                            ></Paginate>
                        </div>
                    </div>
                </div>
            </SimpleApp>
        );
    }
}

export default () => {
    return (
        <SimpleApp>
            <CourseListManager />
        </SimpleApp>
    );
};
